import React from 'react';
import s from './index.module.css';

function Divider() {
  return (
    <hr className={s.divider} />
  );
}

export default Divider;
